import { observer } from 'mobx-react';
import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import { DefaultPageViewModel } from '../default-page.viewmodel';
import { SUPPORT_INFORMATION } from '../../../../../../../../modules/passport-pages/config';
import { FormField } from '../../../../../../../global/form/form-field/form-field';
import { RichTextEditor } from '../../../../../../../global/rich-text-editor';

type Props = {
    pageVm: DefaultPageViewModel;
};


export const SupportPageFields = observer(({ pageVm }: Props): JSX.Element => {
    const { formatMessage } = useIntl();

    const supportInformation = pageVm.getFieldByKey(SUPPORT_INFORMATION);
    const supportInformationLabel = formatMessage(pageVm.getFieldConfigByKey(SUPPORT_INFORMATION).labelDescriptor, { prefix: pageVm.pageName });

    return (
        <>
            <FormField label={supportInformationLabel}>
                <div className='flex'>
                    <RichTextEditor
                        className='oe-form-field__control p-0px m-0px'
                        onBlur={() => pageVm.setValueTouched.bind(pageVm, SUPPORT_INFORMATION)()}
                        value={supportInformation.value as string || ''}
                        onChange={(e, editor) => pageVm.setFieldValueByKey(SUPPORT_INFORMATION, editor.getData())}
                    />
                </div>
                <span className='oe-form-field__error'>
                    {
                        !supportInformation.valid && supportInformation.touched &&
                        <FormattedMessage values={{ fieldName: supportInformationLabel }} {...supportInformation.validationMessage} />
                    }
                </span>
            </FormField>
        </>
    );
});
